
import { OrderInfo } from '@luxtag/papybase';
import { find } from 'lodash';

export const MUTATE_ORDERS = 'MUTATE_ORDERS';
export const ADD_ORDER = 'ADD_ORDER';

interface OrderState {
    orders: OrderInfo[];
}

// initial state
const orderState: OrderState = {
    orders: [],
};

// getters
const getters = {
    getOrders: (state: OrderState) => state.orders,
    getOrder: (state: OrderState) => (orderId: number) => find(
        state.orders, (order: OrderInfo) => order.id === orderId,
    ),
};

// mutations
const mutations = {
    [MUTATE_ORDERS](state: OrderState, payload: OrderInfo[]) {
        state.orders = payload;
    },
    [ADD_ORDER](state: OrderState, payload: OrderInfo) {
        state.orders.push(payload);
    },
};

// actions
const actions = {
    [MUTATE_ORDERS](context: any, payload: any) {
        context.commit(MUTATE_ORDERS, payload);
    },
};


export default {
    state: orderState,
    getters,
    actions,
    mutations,
};
